import apiClient from "./apiClient";

const BASE = "/api/Work";

// API returns workID (no `id`) — alias it so list/edit/select code using `.id` works.
const withId = (w) => ({ ...w, id: w.workID });

export const getWorks = async () => {
  const res = await apiClient.get(`${BASE}/all`);
  return { ...res, data: (res.data || []).map(withId) };
};
export const createWork = (data) => apiClient.post(`${BASE}/save`, data);
export const updateWork = (id, data) => apiClient.post(`${BASE}/save`, { ...data, workID: id });
export const deleteWork = (id) => apiClient.delete(`${BASE}/${id}`);
